import React, { Fragment } from "react";
import { NoRecordsBanner } from '../OopsBanner';

export default function RenderBusinessHero({ data, layout = "1" }: { data: any, layout: string }) {

    let num = parseInt(layout);

    if (isNaN(num) || num < 1) {
        num = 1;
    }


    if (data?.isStenciled) {

        return <div className="stenciled  flex-column gap-small h-full w-full">
            <div className='w-full h-full stencil-item' ></div>
        </div>
    }

    else if (!data || data.length == 0)
        return <NoRecordsBanner message={`Location Image ${num} is not available.`} />


    let imageUrl = data.image ?? "";

    if (data.imageUrls) {
        if (num <= data.imageUrls.length)
            imageUrl = data.imageUrls[num - 1];
        else
            imageUrl = "";
    }
    else if(num > 1){
        imageUrl = "";
    }

    if (imageUrl.length == 0) {
        return <NoRecordsBanner message={`Location Image ${num} is not available.`} />
    }

    return (<Fragment>
        <div className={"w-full h-full " + (data.isStenciled ? "stenciled" : "")}>
            <span className="w-full h-full stencil-item no-a fixed-image-dimension" style={{ display: "block", backgroundImage: `url("${imageUrl}")`, backgroundPosition: "center", backgroundSize: "cover" }}></span>
        </div>
    </Fragment >
    )

}
